var map = {
	"./10k-drive.svg": [
		38329,
		[
			5561
		]
	],
	"./18-plus.svg": [
		91644,
		[
			5561
		]
	],
	"./18plus.svg": [
		10595,
		[
			5561
		]
	],
	"./18plusMrGreen.svg": [
		94935,
		[
			5561
		]
	],
	"./24h.svg": [
		33086,
		[
			5561
		]
	],
	"./888club.svg": [
		36436,
		[
			5561
		]
	],
	"./888club2.svg": [
		62030,
		[
			5561
		]
	],
	"./888wetten.svg": [
		29257,
		[
			5561
		]
	],
	"./AvatarIcon.svg": [
		13628,
		[
			5371
		]
	],
	"./Icon-18.svg": [
		38631,
		[
			5561
		]
	],
	"./Sjalvtest.svg": [
		11514,
		[
			5561
		]
	],
	"./SjalvtestMrGreen.svg": [
		73248,
		[
			5561
		]
	],
	"./Spelgranser.svg": [
		15850,
		[
			5561
		]
	],
	"./SpelgranserMrGreen.svg": [
		464,
		[
			5561
		]
	],
	"./Spelpaus.svg": [
		52875,
		[
			5561
		]
	],
	"./SpelpausMrGreen.svg": [
		62159,
		[
			5561
		]
	],
	"./about-us.svg": [
		7444,
		[
			5561
		]
	],
	"./account-statement.svg": [
		1525,
		[
			5561
		]
	],
	"./account.svg": [
		17653,
		[
			5561
		]
	],
	"./add-user.svg": [
		75535,
		[
			5561
		]
	],
	"./alert.svg": [
		56402,
		[
			5561
		]
	],
	"./app-download.svg": [
		25894,
		[
			5561
		]
	],
	"./az-sports.svg": [
		49087,
		[
			5561
		]
	],
	"./back-btn.svg": [
		84890,
		[
			5561
		]
	],
	"./be-gamble-aware.svg": [
		68169,
		[
			5561
		]
	],
	"./bell.svg": [
		37995,
		[
			5561
		]
	],
	"./bet-feed-old.svg": [
		36966,
		[
			5561
		]
	],
	"./bet-feed.svg": [
		8650,
		[
			5561
		]
	],
	"./betfeed-mrg.svg": [
		82106,
		[
			5561
		]
	],
	"./biometrics-login.svg": [
		26245,
		[
			5561
		]
	],
	"./blog.svg": [
		58756,
		[
			5561
		]
	],
	"./bonuses.svg": [
		46485,
		[
			5561
		]
	],
	"./burger-old.svg": [
		57295,
		[
			5561
		]
	],
	"./burger.svg": [
		51479,
		[
			5561
		]
	],
	"./casino-daily-wish.svg": [
		13123,
		[
			5561
		]
	],
	"./casino-game.svg": [
		69564,
		[
			5561
		]
	],
	"./casino-history.svg": [
		94042,
		[
			5561
		]
	],
	"./casino-mrg.svg": [
		99558,
		[
			5561
		]
	],
	"./casino-si.svg": [
		87870,
		[
			5561
		]
	],
	"./challanges-shield.svg": [
		73424,
		[
			5561
		]
	],
	"./challenges.svg": [
		46866,
		[
			5561
		]
	],
	"./chat.svg": [
		35514,
		[
			5561
		]
	],
	"./check.svg": [
		50240,
		[
			5561
		]
	],
	"./clock.svg": [
		79274,
		[
			5561
		]
	],
	"./close-x.svg": [
		65483,
		[
			5561
		]
	],
	"./close.svg": [
		71084,
		[
			5561
		]
	],
	"./confirmed.svg": [
		87187,
		[
			5561
		]
	],
	"./control-center.svg": [
		63891,
		[
			5561
		]
	],
	"./cool_arrow.svg": [
		99421,
		[
			5561
		]
	],
	"./cross-casino-logo.svg": [
		8492,
		[
			5561
		]
	],
	"./cross-poker-logo.svg": [
		12220,
		[
			5561
		]
	],
	"./cross-sell-casino-mobile.svg": [
		47802,
		[
			5561
		]
	],
	"./cross-sell-casino.svg": [
		44827,
		[
			5561
		]
	],
	"./cross-sell-poker-mobile.svg": [
		51616,
		[
			5561
		]
	],
	"./cross-sell-poker.svg": [
		61253,
		[
			5561
		]
	],
	"./cross-sell-sport-mobile.svg": [
		66783,
		[
			5561
		]
	],
	"./cross-sell-sport.svg": [
		19052,
		[
			5561
		]
	],
	"./cross-sport-logo.svg": [
		14971,
		[
			5561
		]
	],
	"./de-migration-logo.svg": [
		22918,
		[
			5561
		]
	],
	"./default-icon.svg": [
		73587,
		[]
	],
	"./default-logo.svg": [
		58845,
		[
			5561
		]
	],
	"./deposit.svg": [
		85098,
		[
			5561
		]
	],
	"./depositLimit.svg": [
		75575,
		[
			5561
		]
	],
	"./dice.svg": [
		81129,
		[
			5561
		]
	],
	"./disconnect-error.svg": [
		1971,
		[
			5561
		]
	],
	"./disconnect.svg": [
		52270,
		[
			5561
		]
	],
	"./disconnected.svg": [
		95137,
		[
			5561
		]
	],
	"./document-checked.svg": [
		76775,
		[
			5561
		]
	],
	"./document.svg": [
		9387,
		[
			5561
		]
	],
	"./documentWithTimer.svg": [
		49374,
		[
			5561
		]
	],
	"./download-app.svg": [
		710,
		[
			5561
		]
	],
	"./download.svg": [
		73416,
		[
			5561
		]
	],
	"./e-magazine.svg": [
		29600,
		[
			5561
		]
	],
	"./email.svg": [
		9120,
		[
			5561
		]
	],
	"./face-id.svg": [
		22315,
		[
			5561
		]
	],
	"./financial.svg": [
		45117,
		[
			5561
		]
	],
	"./finger-print.svg": [
		42849,
		[
			5561
		]
	],
	"./flag.svg": [
		92982,
		[
			5561
		]
	],
	"./football.svg": [
		25563,
		[
			5561
		]
	],
	"./free-bets.svg": [
		73331,
		[
			5561
		]
	],
	"./free-play.svg": [
		821,
		[
			5561
		]
	],
	"./freespin.svg": [
		70082,
		[
			5561
		]
	],
	"./gam-care.svg": [
		67609,
		[
			5561
		]
	],
	"./game-frame-close.svg": [
		9485,
		[
			5561
		]
	],
	"./game-frame-eighteenplus.svg": [
		42396,
		[
			5561
		]
	],
	"./game-frame-expand.svg": [
		19247,
		[
			5561
		]
	],
	"./game-frame-shrink.svg": [
		24900,
		[
			5561
		]
	],
	"./games.svg": [
		79993,
		[
			5561
		]
	],
	"./gaming.svg": [
		8327,
		[
			5561
		]
	],
	"./gear.svg": [
		51049,
		[
			5561
		]
	],
	"./globe.svg": [
		81503,
		[
			5561
		]
	],
	"./green-gaming.svg": [
		30201,
		[
			5561
		]
	],
	"./help-link.svg": [
		52934,
		[
			5561
		]
	],
	"./help.svg": [
		78601,
		[
			5561
		]
	],
	"./history-new.svg": [
		60549,
		[
			5561
		]
	],
	"./history.svg": [
		28736,
		[
			5561
		]
	],
	"./home-new.svg": [
		84480,
		[
			5561
		]
	],
	"./home.svg": [
		3213,
		[
			5561
		]
	],
	"./hourglass.svg": [
		11958,
		[
			5561
		]
	],
	"./how-to-deposit.svg": [
		53369,
		[
			5561
		]
	],
	"./how-to-play.svg": [
		93735,
		[
			5561
		]
	],
	"./icon-profile.svg": [
		42483,
		[
			5561
		]
	],
	"./info-tip.svg": [
		19956,
		[
			5561
		]
	],
	"./info.svg": [
		51652,
		[
			5561
		]
	],
	"./inplay.svg": [
		93279,
		[
			5561
		]
	],
	"./invite-a-friend.svg": [
		99982,
		[
			5561
		]
	],
	"./leaderboard-new.svg": [
		45880,
		[
			5561
		]
	],
	"./light.svg": [
		98764,
		[
			5561
		]
	],
	"./live-now-side-menu.svg": [
		53045,
		[
			5561
		]
	],
	"./live-old.svg": [
		26914,
		[
			5561
		]
	],
	"./live.svg": [
		19286,
		[
			5561
		]
	],
	"./localization-language.svg": [
		60242,
		[
			5561
		]
	],
	"./localization-pin.svg": [
		33289,
		[
			5561
		]
	],
	"./location-pin.svg": [
		99943,
		[
			5561
		]
	],
	"./location-plugin.svg": [
		10491,
		[
			5561
		]
	],
	"./location-plugin_si.svg": [
		85602,
		[
			5561
		]
	],
	"./location-search-pin.svg": [
		41792,
		[
			5561
		]
	],
	"./locker.svg": [
		74212,
		[
			5561
		]
	],
	"./logo-18-plus.svg": [
		90430,
		[
			5561
		]
	],
	"./logo-DGA-spillemyndigheden.svg": [
		18338,
		[
			5561
		]
	],
	"./logo-SI-desktop-red-white.svg": [
		87899,
		[
			5561
		]
	],
	"./logo-SI-mobile-header-white.svg": [
		63273,
		[
			5561
		]
	],
	"./logo-abon.svg": [
		25760,
		[
			5561
		]
	],
	"./logo-egt.svg": [
		26134,
		[
			5561
		]
	],
	"./logo-mrg-mobile.svg": [
		73925,
		[
			5561
		]
	],
	"./logo-mrg.svg": [
		21894,
		[
			7752
		]
	],
	"./logo-oktocash.svg": [
		67010,
		[
			5561
		]
	],
	"./logo-rofus.svg": [
		66203,
		[
			5561
		]
	],
	"./logo-spil-ansvarligt.svg": [
		32186,
		[
			5561
		]
	],
	"./logo-stop-spillet.svg": [
		69360,
		[
			5561
		]
	],
	"./logout.svg": [
		31834,
		[
			5561
		]
	],
	"./map-circle.svg": [
		22295,
		[
			5561
		]
	],
	"./map-circle_si.svg": [
		95182,
		[
			5561
		]
	],
	"./menu-spinner.svg": [
		58413,
		[
			5561
		]
	],
	"./migrationro-hours.svg": [
		21295,
		[
			5561
		]
	],
	"./migrationro-oneapp.svg": [
		86783,
		[
			5561
		]
	],
	"./migrationro-tournaments.svg": [
		88002,
		[
			5561
		]
	],
	"./mobile-light.svg": [
		91237,
		[
			5561
		]
	],
	"./moneyWallet.svg": [
		21443,
		[
			5561
		]
	],
	"./more.svg": [
		66691,
		[
			5561
		]
	],
	"./mrgreen-myaccount-area.svg": [
		75252,
		[
			5561
		]
	],
	"./notification.svg": [
		29301,
		[
			5561
		]
	],
	"./odds.svg": [
		96958,
		[
			5561
		]
	],
	"./offers.svg": [
		30901,
		[
			5561
		]
	],
	"./perfect-10.svg": [
		11523,
		[
			5561
		]
	],
	"./plus-cashier-mr-green.svg": [
		89234,
		[
			5847
		]
	],
	"./plus-cashier.svg": [
		59388,
		[
			2990
		]
	],
	"./poker-history.svg": [
		89720,
		[
			5561
		]
	],
	"./poker-mrg.svg": [
		3880,
		[
			5561
		]
	],
	"./poker.svg": [
		48039,
		[
			5561
		]
	],
	"./pokerCards.svg": [
		7868,
		[
			5561
		]
	],
	"./pokerDownloadUser.svg": [
		39658,
		[
			5561
		]
	],
	"./poker_logo.svg": [
		60835,
		[
			5561
		]
	],
	"./poker_logo_mobile.svg": [
		50292,
		[
			5561
		]
	],
	"./popular.svg": [
		74175,
		[
			5561
		]
	],
	"./popupLight.svg": [
		34634,
		[
			609
		]
	],
	"./promotions-prelogin.svg": [
		67029,
		[
			5561
		]
	],
	"./promotions.svg": [
		41218,
		[
			5561
		]
	],
	"./question-mark.svg": [
		16090,
		[
			5561
		]
	],
	"./real-money-poker.svg": [
		28291,
		[
			5561
		]
	],
	"./recommendations-old.svg": [
		38440,
		[
			5561
		]
	],
	"./recommendations.svg": [
		50768,
		[
			5561
		]
	],
	"./rectangle-poker.svg": [
		96895,
		[
			5561
		]
	],
	"./redeem-gold-token.svg": [
		62499,
		[
			5561
		]
	],
	"./redirect-focus.svg": [
		63907,
		[
			5561
		]
	],
	"./register.svg": [
		56107,
		[
			5561
		]
	],
	"./responsible-gaming.svg": [
		72426,
		[
			5561
		]
	],
	"./result_arrow.svg": [
		59637,
		[
			5561
		]
	],
	"./reverse-withdraw.svg": [
		45225,
		[
			5561
		]
	],
	"./rewards.svg": [
		84244,
		[
			5561
		]
	],
	"./search.svg": [
		13060,
		[
			5561
		]
	],
	"./security.svg": [
		94090,
		[
			5561
		]
	],
	"./session.svg": [
		84868,
		[
			5561
		]
	],
	"./shield.svg": [
		50811,
		[
			5561
		]
	],
	"./special-offers.svg": [
		32023,
		[
			5561
		]
	],
	"./sport-history.svg": [
		8645,
		[
			5561
		]
	],
	"./sport-mrg.svg": [
		9633,
		[
			5561
		]
	],
	"./sport.svg": [
		48142,
		[
			5561
		]
	],
	"./sport_cross_sell.svg": [
		70114,
		[
			5561
		]
	],
	"./sport_logo.svg": [
		62056,
		[
			5561
		]
	],
	"./sport_logo_VIP.svg": [
		63296,
		[
			5561
		]
	],
	"./sport_logo_mobile.svg": [
		6805,
		[
			5561
		]
	],
	"./sportwetten.svg": [
		94247,
		[
			5561
		]
	],
	"./sportwetten_VIP.svg": [
		90939,
		[
			5561
		]
	],
	"./sportwetten_mobile.svg": [
		7624,
		[
			5561
		]
	],
	"./star-empty.svg": [
		97484,
		[
			5561
		]
	],
	"./star.svg": [
		52344,
		[
			5561
		]
	],
	"./starting_soon.svg": [
		2018,
		[
			5561
		]
	],
	"./theme-mode.svg": [
		27505,
		[
			5561
		]
	],
	"./ticket.svg": [
		46444,
		[
			5561
		]
	],
	"./tickets-new.svg": [
		51482,
		[
			5561
		]
	],
	"./title_races.svg": [
		28709,
		[
			5561
		]
	],
	"./touch-id.svg": [
		56441,
		[
			5561
		]
	],
	"./tournament-tickets.svg": [
		22941,
		[
			5561
		]
	],
	"./tournaments.svg": [
		91208,
		[
			5561
		]
	],
	"./tribal-white.svg": [
		25324,
		[
			5561
		]
	],
	"./up-for-8.svg": [
		36654,
		[
			5561
		]
	],
	"./upload-documents.svg": [
		69094,
		[
			5561
		]
	],
	"./user-default-icon.svg": [
		51793,
		[
			5561
		]
	],
	"./user-details.svg": [
		53824,
		[
			5561
		]
	],
	"./user-icon-pre-login-default.svg": [
		15845,
		[
			5561
		]
	],
	"./user.svg": [
		62777,
		[
			5561
		]
	],
	"./vi-cross-sell-casino-mobile.svg": [
		59878,
		[
			5561
		]
	],
	"./vi-cross-sell-poker-mobile.svg": [
		81316,
		[
			5561
		]
	],
	"./vi-logo.svg": [
		98785,
		[
			5561
		]
	],
	"./virtual-sports.svg": [
		82463,
		[
			5561
		]
	],
	"./wallet.svg": [
		5799,
		[
			5561
		]
	],
	"./winloss-history.svg": [
		66492,
		[
			5561
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 13254;
module.exports = webpackAsyncContext;